export default [
      {
            path: '/liquidacion-prima/index',
            name: 'LiquidacionView',
            component: () => import('../views/recaudacion/LiquidacionView.vue'),
      }, 
      {
            path: '/liquidacion-comision-prima/index',
            name: 'LiquidacionComisionView',
            component: () => import('../views/recaudacion/LiquidacionComisionView.vue'),
      }, 
]